import { Tag, Loader2 } from 'lucide-react';
import { UserTag } from '@/types';
import { cn } from '@/lib/utils';

interface TagSelectorProps {
  availableTags: UserTag[];
  selectedTags: string[];
  toggleTag: (tagId: string) => void;
  showNewTagInput: boolean;
  setShowNewTagInput: (show: boolean) => void;
  newTagName: string;
  setNewTagName: (name: string) => void;
  handleCreateTag: () => void;
  isCreatingTag: boolean;
}

// Tag selector + new-tag input. Purely presentational: all tag state and creation
// logic stays in the parent and is passed in via props.
export default function TagSelector({
  availableTags,
  selectedTags,
  toggleTag,
  showNewTagInput,
  setShowNewTagInput,
  newTagName,
  setNewTagName,
  handleCreateTag,
  isCreatingTag,
}: TagSelectorProps) {
  return (
    <div>
      <label className="flex items-center gap-2 text-sm font-medium mb-3">
        <Tag className="w-4 h-4" />
        תגיות
      </label>
      <div className="flex flex-wrap gap-2">
        {availableTags.map((tag) => (
          <button
            key={tag.id}
            onClick={() => toggleTag(tag.id)}
            className={cn(
              "px-3 py-1.5 rounded-full text-sm font-medium transition-all",
              selectedTags.includes(tag.id)
                ? "bg-primary text-primary-foreground"
                : "bg-secondary text-secondary-foreground hover:bg-secondary/80"
            )}
          >
            {tag.tagName}
          </button>
        ))}
        <button
          type="button"
          onClick={() => setShowNewTagInput(true)}
          className="px-3 py-1.5 rounded-full text-sm font-medium transition-all bg-secondary text-secondary-foreground hover:bg-secondary/80"
        >
          + הוסף תגית
        </button>
      </div>
      {showNewTagInput && (
        <div className="flex items-center gap-2 mt-3">
          <input
            type="text"
            value={newTagName}
            onChange={(e) => setNewTagName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleCreateTag();
              }
            }}
            disabled={isCreatingTag}
            placeholder="שם תגית חדשה"
            autoFocus
            className="flex-1 px-4 py-2 rounded-xl border border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50"
          />
          <button
            type="button"
            onClick={handleCreateTag}
            disabled={isCreatingTag || !newTagName.trim()}
            className="px-4 py-2 rounded-xl bg-primary text-primary-foreground text-sm font-medium disabled:opacity-50 flex items-center gap-2 whitespace-nowrap"
          >
            {isCreatingTag ? <Loader2 className="w-4 h-4 animate-spin" /> : 'הוסף'}
          </button>
        </div>
      )}
    </div>
  );
}
